module.exports = __webpack_public_path__ + "img/repsol_logo.6e262aaf.png";